import {create} from 'zustand';
import { login as apiLogin, logout as apiLogout, register as apiRegister, getCurrentUser, LoginCredentials, RegisterCredentials, /*processOauthCallback*/ } from '../utils/api';
import { User } from '../interfaces/User';

interface AuthState {
  isAuthenticated: boolean;
  user: User | null;
  login: (credentials: LoginCredentials) => Promise<void>;
  register: (credentials: RegisterCredentials) => Promise<void>;
  oauthLogin: (provider:string, code:string) => Promise<void>; //TODO
  loginAfterOauthCallback: (provider: string) => Promise<void>;
  logout: () => Promise<void>;
  checkAuth: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  isInitialized: false,
  isAuthenticated: false,
  user: null,
  login: async (credentials: LoginCredentials) => {
    try {
      const user = await apiLogin(credentials);
      console.log("user",user)
      set({ isAuthenticated: true, user });
    } catch (error) {
      if (error instanceof Error) {
        throw error;
      }
      throw new Error('An unexpected error occurred during login');
    }
  },
  register: async (credentials: RegisterCredentials) => {
    try {
      const user = await apiRegister(credentials);
      //console.log("user",user)
      set({ isAuthenticated: true, user });
    } catch (error) {
      if (error instanceof Error) {
        throw error;
      }
      throw new Error('An unexpected error occurred during login');
    }
  },
  oauthLogin: async (provider:string, code:string) => {
    //TODO
    console.log("TODO oauthLogin", provider, code)
  }, 
  logout: async () => {
    try {
      await apiLogout();
      set({ isAuthenticated: false, user: null });
    } catch (error) {
      if (error instanceof Error) {
        throw error;
      }
      throw new Error('An unexpected error occurred during logout');
    }
  },
  loginAfterOauthCallback: async (provider:string) => {
    try {
      console.log("provider not initialized:", provider)
      //const user = await processOauthCallback(provider);
      //console.log("user",user)
      //set({ isAuthenticated: true, user });
    } catch (error) {
      if (error instanceof Error) {
        throw error;
      }
      throw new Error('An unexpected error occurred during login');
    }
  },
  checkAuth: async () => {
    try {
      const user = await getCurrentUser();
     // console.log("user",user)
      set({ isAuthenticated: true, user });
    } catch (error) {
      set({ isAuthenticated: false, user: null });
    }
  }
}));
